/**
 * Opções de configuração da escrita do solicitante no chat.
 *
 * O valor é tri-estado de propósito: `null` significa "não configurado neste
 * nível", e é o que faz a resolução continuar descendo a hierarquia
 * balcão → vara → comarca. Sem esse terceiro estado não haveria como
 * desconfigurar um nível depois de configurá-lo.
 *
 * Os rótulos chegam prontos porque a nomenclatura muda por cliente e vive no
 * i18n (chaves `requesterChat.*`) — este arquivo não conhece texto fixo.
 *
 * Ver ADR-008 no vault.
 */
export function requesterChatOptions({ inherit, allow, block }) {
  return [
    { text: inherit, value: null },
    { text: allow, value: true },
    { text: block, value: false },
  ];
}
